export default "__VITE_ASSET__BwPQJ3dE__"